import React, { useState, useEffect } from 'react';
import { loadNavigationClientSide } from '../helper/api'
import { NavigationEntry } from '../helper/interfaces';

type CacheContext = { 
  navigationEntries: NavigationEntry[];
}

export const CacheContext = React.createContext<CacheContext>(
  {} as CacheContext
);

type CacheContextProviderProps = {
  children: React.ReactNode;
};

export const CacheContextProvider: React.FC<CacheContextProviderProps> = ({ children }) => {
  const [navigation, setNavigation] = useState<NavigationEntry[]>([]);

  const checkAndLoadChildren = async (items: NavigationEntry[]) => {
    for(let i = 0; i < items.length; i++) {
      let entry = items[i];
      if(entry.children?.length > 0) {
        const children = await checkAndLoadChildren(entry.children);
        entry.children = children;
      }
      if(entry.extendable) {
        const navigationEntry = await loadNavigationClientSide(entry.id)
        if(navigationEntry?.children?.length && navigationEntry.children.length > 0) {
          const children = await checkAndLoadChildren(navigationEntry.children);
          entry.children = children;
        }
        entry.extendable = false
      }
    }
    return items;
  }

  const loadNavigationFromApi = async () => {
    const navigationEntry = await loadNavigationClientSide(undefined)
    if(navigationEntry?.children?.length && navigationEntry.children.length > 0) {
      const children = await checkAndLoadChildren(navigationEntry.children);

      setNavigation(children)
    }
  }
  
  useEffect(() => {
    loadNavigationFromApi()
  }, [])

  return (
    <CacheContext.Provider value={{ navigationEntries: navigation }}>
      {children}
    </CacheContext.Provider>
  );
};